export default __webpack_public_path__ + "static/media/proj8.4f65de35.png";